import type { ButtonHTMLAttributes, FC } from 'react';
import { IconComponent } from '@/components/IconComponent';
import { ScButtonClose } from './styled';

export const ButtonClose: FC<ButtonHTMLAttributes<HTMLButtonElement>> = (
  props
) => (
  <ScButtonClose {...props}>
    <IconComponent className="close-icon" name="closeIcon" />
  </ScButtonClose>
);
